import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Card,
  CardContent,
  CardHeader,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
  Box,
} from '@mui/material'
import { Enrollment } from '../../types/dashboard'

interface UpcomingDeadlinesProps {
  deadlines: Enrollment[]
  onViewAll?: () => void
}

export const UpcomingDeadlines: React.FC<UpcomingDeadlinesProps> = ({ deadlines, onViewAll }) => {
  const { t, i18n } = useTranslation('dashboard')

  return (
    <Card>
      <CardHeader title={t('upcomingDeadlines.title')} />
      <CardContent sx={{ pt: 0 }}>
        {deadlines.length === 0 ? (
          <Typography variant="body2" color="textSecondary" textAlign="center" py={2}>
            {t('upcomingDeadlines.noDeadlines')}
          </Typography>
        ) : (
          <List disablePadding>
            {deadlines.map((enrollment, index) => (
              <ListItem
                key={enrollment.id}
                sx={{
                  px: 0,
                  borderBottom: index < deadlines.length - 1 ? '1px solid #f0f0f0' : 'none',
                }}
              >
                <ListItemText
                  primary={enrollment.test.title}
                  secondary={
                    <Typography
                      component="span"
                      variant="body2"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: 1,
                        flexWrap: { xs: 'wrap', sm: 'nowrap' },
                      }}
                    >
                      <Typography
                        component="span"
                        variant="caption"
                        color="textSecondary"
                        sx={{
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          minWidth: 0,
                          flexGrow: { xs: 0, sm: 1 },
                        }}
                      >
                        {enrollment.test.complianceRule.category}
                      </Typography>
                      <Typography
                        component="span"
                        variant="caption"
                        color="error"
                        sx={{ flexShrink: 0 }}
                      >
                        {new Date(enrollment.dueDate).toLocaleDateString(
                          i18n.language === 'en' ? 'en-US' : 'ja-JP'
                        )}
                      </Typography>
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
        {deadlines.length > 0 && onViewAll && (
          <Box textAlign="center" mt={2}>
            <Button variant="outlined" onClick={onViewAll}>
              {t('upcomingDeadlines.viewAll')}
            </Button>
          </Box>
        )}
      </CardContent>
    </Card>
  )
}
